<template>
  <div>
    <div v-if="showChapterContent">
      <div class="content-box__add-new" v-if="!messageContent">
        <div v-if="chapterMessage.canEdit && !isEditing">
          <v-btn flat class="content-box__add-new-button" data-qe-id="add_new_feature_item_btn"
            id="add_new_feature_item" @click="onAddNewClick">
            {{ addNewMessageText }}
          </v-btn>
        </div>
        <div v-else-if="!chapterMessage.canEdit && !isUserMemberOfCurrentCommunity && !isTeamMember && isChapterRoute">
          <span>{{ communityCommonConstant.ActivityFeed.ALL_COMMUNITY_NON_MEMBER_MESSAGE }} chapter.</span>
        </div>
        <div v-else-if="!chapterMessage.canEdit && !isUserMemberOfCurrentCommunity && !isTeamMember && isNetworkRoute">
          <span>{{ communityCommonConstant.ActivityFeed.ALL_COMMUNITY_NON_MEMBER_MESSAGE }} network.</span>
        </div>
      </div>
      <div v-else>
        <div v-if="!isEditing">
          <div class="chapter-non-member-message py-2">
            <div v-if="chapterWelcomeImageData" class="content-box__banner-image">
              <v-img :src="sizeFormattedImageUrlWithFaceFocused(chapterMessage.imageURL, 500, 1500)" :onerror="imageErrorFallback(this.chapterMessage.fallbackImageURL)" class="content-box__img">
                <div v-if="chapterMessage.canEdit">
                  <i class="fas fa-pencil-alt content-box__edit-btn" @click="editChapterWelcomeMessage()"></i>
                </div>
              </v-img>
            </div>
            <div v-if="chapterWelcomeMessageData" class="content-box">
              <div v-if="chapterMessage.canEdit" class="flex text-xs-right">
                <i class="fas fa-pencil-alt content-box__edit-btn" @click="editChapterWelcomeMessage()"></i>
              </div>
              <div class="content-box__box-description">
                <p v-html="chapterMessage.message"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isEditing">
        <v-card class="chapter-welcome-message-edit">
          <div class="chapter-welcome-message-edit__image">
            <div v-if="imageURL" class="chapter-welcome-message-edit__image-frame">
              <div class="chapter-welcome-message-edit__image-container">
                <v-img :src="imageURL" cover class="content-box__img"></v-img>
                <v-icon class="chapter-welcome-message-edit__image-remove" @click="removePostImage">close
                </v-icon>
              </div>
            </div>
          </div>
          <div class="chapter-welcome-message__editor">
            <ck-editor :editor-id="ckEditorId" :editor-type="ckEditorType.BASIC" :can-upload-image="!imageURL"
              v-model="newChapterWelcomeMessage.message" :input-filter-for-image="inputFilterForImageFile"
              :update-image-upload="updateFile" height="350">
            </ck-editor>
          </div>
          <status-bar :action="addPostAction"></status-bar>
          <div class="bottom-section-edit">
            <div class="bottom-section-edit__swicth">
              <v-switch v-model="showChapterWelcomeMessage" class="toggle-switch"
                :label="communityCommonConstant.DISPLAY_NON_MEMBER" hide-details></v-switch>
            </div>
            <div class="bottom-section-edit__buttons">
              <v-btn class="primary_btn transparent small" data-qe-id="cancel_dialog_btn" flat
                @click.native="resetChapterWelcomeMessage">
                CANCEL
              </v-btn>
              <v-btn class="primary_btn" @click="saveChapterWelcomeMessage">
                SAVE
              </v-btn>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <div v-else-if="!isTeamMember && isChapterRoute">
      <span>{{ communityCommonConstant.ActivityFeed.ALL_COMMUNITY_NON_MEMBER_MESSAGE }} chapter.</span>
    </div>
    <div v-else-if="!isTeamMember && isNetworkRoute">
      <span>{{ communityCommonConstant.ActivityFeed.ALL_COMMUNITY_NON_MEMBER_MESSAGE }} network.</span>
    </div>
  </div>
</template>

<script>
  import { imageErrorFallback, getRandomId } from '@/common/utils/utils';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import { storeAction } from "@/store/storeActions.constant";
  import { storeGetters } from '../../store/storeGetters.constant';
  import { communityCommonConstant } from './communityCommon.constant';
  import ckEditor from "../CkEditor/CkEditor";
  import { ckEditorType } from "../../plugins/CkEditor/ckEditorTypes.config";
  import MemberMentionTextArea from '../CkEditor/MemberMentionTextArea';
  import { createFormDataForSelectedFiles, getUploadedFileBase64, inputFilterForImageFile } from "@/common/utils/fileUploader";
  import FileUpload from 'vue-upload-component';
  import cloneDeep from "lodash/cloneDeep";
  import StatusBar from "../../components/StatusBar/StatusBar";
  import { sizeFormattedImageUrlWithFaceFocused } from "@/common/utils/cloudinaryUtils";
  import { routerNames } from '../appCommon.constants';


  export default {
    data: () => ({
      communityCommonConstant,
      ckEditorType,
      editChapterMessage: false,
      ckEditorId: getRandomId(),
      FileUpload,
      files: [],
      showToNonMember: false,
      showToManager: false,
      isEditing: false,
      showChapterWelcomeMessage: true,
      showChapterRequirements: false,
      uploadedImageName: '',
      newChapterWelcomeMessage: {},
      imageErrorFallback,
      sizeFormattedImageUrlWithFaceFocused,
      routerNames,
    }),
    components: {
      StatusBar,
      ckEditor,
      MemberMentionTextArea,
      FileUpload,
    },
    async created() {
      await this.fetchChapterWelcomeMessage();
    },

    computed: {
      ...mapGetters({
        chapterMessage: `chapter/${storeGetters.chapterMessage}`,
        isUserMemberOfCommunity: `chapter/${storeGetters.isUserMemberOfCommunity}`,
        userPermissionsData: `auth/${storeGetters.permissionsData}`,
      }),
      ...mapState("actionState", ["actions"]),

      addPostAction() {
          return this.actions[storeAction.createChapterMessage];
      },
      imageURL() {
        if (this.files.length && this.files[0].url) {
          return this.files[0].url;
        } else if (this.newChapterWelcomeMessage && this.newChapterWelcomeMessage.imageURL) {
          return this.newChapterWelcomeMessage.imageURL;
        }
      },
      isChapterRoute() {
        return this.$route.name === this.routerNames.CHAPTER;
      },
      isNetworkRoute() {
        return this.$route.name === this.routerNames.NETWORK;
      },
      isTeamMember() {
          return this.userPermissionsData && this.userPermissionsData.userRoles && this.userPermissionsData.userRoles.some(o => o === "Team Member");
      },
      fallbackImageURL() {
        return this.chapterMessage.fallbackImageURL;
      },
      messageContent() {
        return this.chapterWelcomeMessageData || this.chapterWelcomeImageData;
      },
      chapterWelcomeMessageData() {
        return this.chapterMessage.message && this.chapterMessage.message.length;
      },
      chapterWelcomeImageData() {
        return this.chapterMessage.imageURL && this.chapterMessage.imageURL.length;
      },
      isUserMemberOfCurrentCommunity() {
        const currentCommunityId = this.$route.params.communityId;
        return this.isUserMemberOfCommunity(currentCommunityId);
      },
      communityData() {
        return this.chapterMessage.community;
      },
      communityId() {
        return this.$route.params.communityId;
      },
      showChapterContent() {
        return this.chapterMessage && (this.chapterMessage.showChapterWelcomeMessage || this.chapterMessage.canEdit || this.isUserMemberOfCurrentCommunity);
      },
      addNewMessageText() {
        const messageMap = {
          [this.routerNames.CHAPTER]: this.communityCommonConstant.featureEvent.ADD_WELCOME_MESSAGE,
          [this.routerNames.NETWORK]: this.communityCommonConstant.featureEvent.ADD_NETWORK_WELCOME_MESSAGE,
        };
        return messageMap[this.$route.name] || null;
      },
    },

    methods: {
      ...mapActions({
        getChapterMessage: `chapter/${storeAction.getChapterMessage}`,
        createChapterMessage: `chapter/${storeAction.createChapterMessage}`,
      }),
      async fetchChapterWelcomeMessage() {
        try {
          await this.getChapterMessage(this.$route.params.communityId);
          this.newChapterWelcomeMessage = cloneDeep(this.chapterMessage);
        } catch (error) {
          console.error('Error fetching message:', error);
        }
      },
      onAddNewClick() {
        this.isEditing = true;
        this.files = [];
        this.uploadedImageName = '';
        this.newChapterWelcomeMessage.fileName = '';
      },
      editChapterWelcomeMessage() {
        this.isEditing = !this.isEditing;
        if (this.isEditing) {
          this.newChapterWelcomeMessage.message = this.chapterMessage.message;
          this.showChapterWelcomeMessage = this.chapterMessage.showChapterWelcomeMessage;
          this.showChapterRequirements = this.chapterMessage.showChapterRequirements;
        }
      },
      resetChapterWelcomeMessage() {
        this.newChapterWelcomeMessage = cloneDeep(this.chapterMessage);
        this.newChapterWelcomeMessage.imageURL = this.chapterMessage.imageURL;
        this.newChapterWelcomeMessage.message = this.chapterMessage.message;
        this.files = [];
        this.isEditing = false;
      },
      showToast(type) {
        const routeName = this.$route.name;
        const message =
          this.communityCommonConstant.TOAST_MESSAGES[routeName] &&
          this.communityCommonConstant.TOAST_MESSAGES[routeName][type];

        if (message) {
          this.$store.dispatch(`snackbar/${storeAction.setToastMessage}`, {
            color: type === 'success' ? 'success' : 'error',
            message,
          });
        }
      },
      async saveChapterWelcomeMessage() {
        const {
          message,
        } = this.newChapterWelcomeMessage;

        const formData = createFormDataForSelectedFiles([...this.files]);
        formData.append('message', message);
        formData.append('id', this.chapterMessage.id || '');
        formData.append('communityId', this.communityId);
        formData.append('showChapterWelcomeMessage', this.showChapterWelcomeMessage);
        formData.append('showChapterRequirements', this.showChapterRequirements);
        formData.append('isActive', true);
        formData.append('imageURL', (this.uploadedImageName || this.newChapterWelcomeMessage.fileName));
        try {
          await this.createChapterMessage(formData);
          this.showToast('success');
        } catch (err) {
          this.showToast('error');

          this.newChapterWelcomeMessage.imageURL = this.chapterMessage.imageURL;
          this.newChapterWelcomeMessage.message = this.chapterMessage.message;
        }
        this.isEditing = false;
      },
      formatValue(value) {
        return (value != null && !isNaN(value)) ? `${value}M` : 'N/A';
      },
      getDataValue(key) {
        return this.communityData[key];
      },
      inputFilterForImageFile,
      updateFile(files) {
        if (files && files.length) {
          this.files = files;
          this.newChapterWelcomeMessage.imageURL = {
            ...this.newChapterWelcomeMessage.imageURL,
            url: this.files[0] && this.files[0].url ? this.files[0].url : "",
          };
          const { file } = this.files[0];
          this.uploadedImageName = file.name;
          getUploadedFileBase64(file).then((customJsonFile) => {
            if (customJsonFile) {
              this.newChapterWelcomeMessage.imageURL = {
                data: customJsonFile.base64StringFile,
                contentType: customJsonFile.fileType,
              };
            } else {
              this.uploadedImageName = '';
              throw new Error("File not loaded.");
            }
          });
        }
      },
      removePostImage() {
        this.newChapterWelcomeMessage.imageURL = null;
        this.files = [];
        this.uploadedImageName = '';
        this.newChapterWelcomeMessage.fileName = '';
      },
    }
  };
</script>

<style lang="scss">
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";

.category-title {
  font-weight: 700;
  font-size: 16px;
}

.content-box {
  position: relative;
  border: 1px solid $ypo-about-border;
  background-color: #ffff;
  margin-bottom: 15px;

  &__add-new {
    max-height: 80px;
    margin-bottom: 20px;

    &-button {
      width: 100%;
      margin: 0;
      font-size: 16px;
      padding: 10px;
      font-weight: 600;
      color: $ypo-cta;
      border: 1px solid $ypo-cta;
      border-radius: 4px;
      height: auto;
    }
  }

  &__banner-image {
    display: flex;
    flex-direction: column;
    margin-bottom: 25px;
  }

  &__img {
    height: 230px;
    width: 100%;
    object-fit: cover;
  }

  &__heading {
    padding: 15px;
    font-weight: 700;
    font-size: 16px;
  }

  &__box-description {
    padding-right: 10px;
    padding-left: 10px;
    padding-top: 10px;
  }

  &__more-option {
    bottom: 5px;
    right: 5px;
  }

  &__edit-btn {
    position: absolute;
    background-color: white;
    padding: 7px;
    border-radius: 50%;
    margin: 4px;
    z-index: 24;
    right: 2px;
    cursor: pointer;
  }
}

.chapter-welcome-message-edit {
  margin-bottom: 10px;
  border: 1px solid black !important;

  &__image {
    &-upload {
      text-align: right;
    }

    &-frame {
      padding: 10px;
      padding-left: 23px;
      padding-right: 23px;
      max-height: 250px;
      overflow-y: auto;
    }

    &-container {
      position: relative;
    }

    &-remove {
      position: absolute !important;
      z-index: 10000;
      top: 0px;
      right: -23px;
      border: none;
      color: $ypo-blue;
    }
  }
}

.bottom-section-edit {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-top: 1px solid gray;

  @include breakpoint(xs) {
    display: flex;
    flex-direction: column;
  }

  &__swicth {
    padding: 10px;
  }

  &__buttons {
    display: flex;
    justify-content: space-between;
  }
}
</style>

<style lang="scss" scoped>

.chapter-welcome-message {
  .photo-uploader__btn {
    padding: 2px 5px 5px !important;
    height: 25px;
  }

  .cke_contents {
    height: 270px !important;
  }

  .ck-editor__image-upload {
    top: 5px;
    right: 5px;
  }

  &__editor {
    margin: 10px;
  }
}
</style>
